import React, { useState, handlelick, active, useContext } from "react";
import "./Sidebar.css";
import { Link, useLocation } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import Accordion from "react-bootstrap/Accordion";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCar,
  faCircleExclamation,
  faCircleInfo,
  faComment,
  faFileCircleExclamation,
  faGear,
  faHeadset,
  faHouse,
  faList,
  faLocationDot,
  faShieldHalved,
  faTruck,
  faTv,
  faUser,
  faUsers,
  faWallet,
  fas,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";
import { Context } from "../../../utils/context";
import { faAdversal } from "@fortawesome/free-brands-svg-icons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
library.add(fas);

const Sidebar = () => {
  const { isAllow } = useContext(Context);
  const [isOpen, setIsOpen] = useState(true);

  const location = useLocation();
  const [headerText, setHeaderText] = useState(location.pathname);

  useEffect(() => {
    setHeaderText(location.pathname);
  }, [location.pathname]);

  const [active, setActive] = useState("1");

  const [activeAccordionItem, setActiveAccordionItem] = useState("1");
  const [activeInnerListItem, setActiveInnerListItem] = useState(null);

  const handleAccordionClick = (itemKey) => {
    setActiveAccordionItem(itemKey === activeAccordionItem ? null : itemKey);
  };

  const handleInnerListItemClick = (itemId) => {
    setActiveInnerListItem(itemId === activeInnerListItem ? null : itemId);
  };

  const renderTooltip = (name) => (props) =>
    (
      <Tooltip id="button-tooltip" {...props}>
        {name}
      </Tooltip>
    );

  return (
    <>
      <section style={{ width: isOpen ? "250px" : "50px" }} className="sidebar">
        <div className="top_section">
          {isOpen && (
            <Link
              to="/dashboard"
              className="link-body-emphasis d-inline-flex text-decoration-none rounded"
            >
              <div className="img-holder">
                <img
                  className="logo-img"
                  src={process.env.PUBLIC_URL + "/assets/Image/Logo.png"}
                  alt="logo-img"
                />
              </div>
            </Link>
          )}
          <div style={{ marginLeft: isOpen ? "30px" : "3px" }} className="bars">
            <FaBars onClick={() => setIsOpen(!isOpen)} />
          </div>
        </div>

        <ul className="list-unstyled ps-0">
          <Accordion defaultActiveKey={activeAccordionItem}>
            {/* dashboard tab start*/}
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip("Dashboard")}
              // eventKey="1"
            >
              <Accordion.Item
                eventKey="1"
                className={`mb-1 ${
                  activeAccordionItem === "1"
                    ? "accordian-holder active"
                    : "accordian-holder"
                }`}
                onClick={() => handleAccordionClick("1")}
              >
                <Link to="/dashboard" className="text-decoration-none ">
                  <Accordion.Header>
                    <div className="text-clr me-3">
                      <FontAwesomeIcon
                        icon={faHouse}
                        style={{ color: "rgb(45, 206, 137)" }}
                      />
                    </div>
                    <p
                      // onClick={() => setIsOpen(!isOpen)}
                      style={{ display: isOpen ? "block" : "none" }}
                    >
                      Dashboard
                    </p>
                  </Accordion.Header>
                </Link>
              </Accordion.Item>
              {/* dashboard tab end*/}
            </OverlayTrigger>

            {/* settings tab start*/}
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip("settings")}
              eventKey="2"
            >
              <Accordion.Item
                // eventKey="2"
                // className="mb-1"
                // onClick={() => setIsOpen(true)}
                eventKey="2"
                className={`mb-1 ${
                  activeAccordionItem === "2" ? "active" : ""
                }`}
                onClick={() => handleAccordionClick("2")}
              >
                <Accordion.Header>
                  <div className="text-clr  me-3">
                    <FontAwesomeIcon
                      icon={faGear}
                      style={{ color: "rgb(45, 206, 137)" }}
                    />
                  </div>
                  <p
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    Settings
                  </p>
                </Accordion.Header>
                <Accordion.Body
                  style={{
                    display: isOpen ? "block" : "none",
                  }}
                >
                  <ul className=" list-unstyled fw-normal pb-1 small">
                    <li
                      className={`${
                        isOpen
                          ? headerText.includes("/masters/app-setup")
                            ? "active block"
                            : "none"
                          : "none"
                      }`}
                      onClick={() => handleInnerListItemClick("app-setup")}
                    >
                      <Link
                        to="/masters/app-setup"
                        className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                      >
                        <p
                          // onClick={() => setIsOpen(!isOpen)}
                          style={{ display: isOpen ? "block" : "none" }}
                        >
                          App Setup
                        </p>
                      </Link>
                    </li>

                    {/* Country */}

                    {/* <li
                      className={`${
                        isOpen
                          ? headerText.includes(
                              "/masters/booking-cancel-reasons"
                            )
                            ? "active block"
                            : "none"
                          : "none"
                      }`}
                      onClick={() =>
                        handleInnerListItemClick("booking-cancel-reasons")
                      }
                    >
                      <Link
                        to="/masters/booking-cancel-reasons"
                        className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                      >
                        <p
                          // onClick={() => setIsOpen(!isOpen)}
                          style={{ display: isOpen ? "block" : "none" }}
                        >
                          Booking Cancel Reasons
                        </p>
                      </Link>
                    </li> */}

                    <li
                      className={`${
                        isOpen
                          ? headerText.includes("/masters/goods-type")
                            ? "active block"
                            : "none"
                          : "none"
                      }`}
                      onClick={() => handleInnerListItemClick("goods-type")}
                    >
                      <Link
                        to="/masters/goods-type"
                        className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                      >
                        <p
                          // onClick={() => setIsOpen(!isOpen)}
                          style={{ display: isOpen ? "block" : "none" }}
                        >
                          Goods Type
                        </p>
                      </Link>
                    </li>

                    <li
                      className={`${
                        isOpen
                          ? headerText.includes("/masters/save-as")
                            ? "active block"
                            : "none"
                          : "none"
                      }`}
                      onClick={() => handleInnerListItemClick("save-as")}
                    >
                      <Link
                        to="/masters/save-as"
                        className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                      >
                        <p
                          // onClick={() => setIsOpen(!isOpen)}
                          style={{ display: isOpen ? "block" : "none" }}
                        >
                          Save As
                        </p>
                      </Link>
                    </li>

                    <li
                      className={`${
                        isOpen
                          ? headerText.includes("/masters/covered")
                            ? "active block"
                            : "none"
                          : "none"
                      }`}
                      onClick={() => handleInnerListItemClick("covered")}
                    >
                      <Link
                        to="/masters/covered"
                        className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                      >
                        <p
                          // onClick={() => setIsOpen(!isOpen)}
                          style={{ display: isOpen ? "block" : "none" }}
                        >
                          Vehicle Body
                        </p>
                      </Link>
                    </li>

                    <li
                      className={`${
                        isOpen
                          ? headerText.includes("/masters/category-vehicle")
                            ? "active block"
                            : "none"
                          : "none"
                      }`}
                      onClick={() =>
                        handleInnerListItemClick("category-vehicle")
                      }
                    >
                      <Link
                        to="/masters/category-vehicle"
                        className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                      >
                        <p
                          // onClick={() => setIsOpen(!isOpen)}
                          style={{ display: isOpen ? "block" : "none" }}
                        >
                          Vehicle Category
                        </p>
                      </Link>
                    </li>

                    {/* <li
                      className={`${
                        isOpen
                          ? headerText.includes("/masters/fare-vehicle")
                            ? "active block"
                            : "none"
                          : "none"
                      }`}
                      onClick={() => handleInnerListItemClick("fare-vehicle")}
                    >
                      <Link
                        to="/masters/fare-vehicle"
                        className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                      >
                        <p
                          // onClick={() => setIsOpen(!isOpen)}
                          style={{ display: isOpen ? "block" : "none" }}
                        >
                          Vehicle Fare
                        </p>
                      </Link>
                    </li> */}

                    <li
                      className={`${
                        isOpen
                          ? headerText.includes("/masters/vehicle")
                            ? "active block"
                            : "none"
                          : "none"
                      }`}
                      onClick={() => handleInnerListItemClick("vehicle")}
                    >
                      <Link
                        to="/masters/vehicle"
                        className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                      >
                        <p
                          // onClick={() => setIsOpen(!isOpen)}
                          style={{ display: isOpen ? "block" : "none" }}
                        >
                          Vehicle
                        </p>
                      </Link>
                    </li>
                  </ul>
                  {/* </div> */}
                </Accordion.Body>
              </Accordion.Item>
            </OverlayTrigger>

            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip("Location")}
              eventKey="3"
            >
              <Accordion.Item
                // eventKey="2"
                // className="mb-1"
                // onClick={() => setIsOpen(true)}
                eventKey="3"
                className={`mb-1 ${
                  activeAccordionItem === "3" ? "active" : ""
                }`}
                onClick={() => handleAccordionClick("3")}
              >
                <Accordion.Header>
                  <div className="text-clr  me-3">
                    <FontAwesomeIcon
                      icon={faLocationDot}
                      style={{ color: "rgb(45, 206, 137)" }}
                    />
                  </div>
                  <p
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    Location
                  </p>
                </Accordion.Header>
                <Accordion.Body
                  style={{
                    display: isOpen ? "block" : "none",
                  }}
                >
                  <ul className=" list-unstyled fw-normal pb-1 small">
                    {/* Language */}
                    <li
                      className={`${
                        isOpen
                          ? headerText.includes("/masters/country")
                            ? "active block"
                            : "none"
                          : "none"
                      }`}
                      onClick={() => handleInnerListItemClick("country")}
                    >
                      <Link
                        to="/masters/country"
                        className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                      >
                        <p
                          // onClick={() => setIsOpen(!isOpen)}
                          style={{ display: isOpen ? "block" : "none" }}
                        >
                          Country
                        </p>
                      </Link>
                    </li>
                    {/* State */}
                    <li
                      className={`${
                        isOpen
                          ? headerText.includes("/masters/state")
                            ? "active block"
                            : "none"
                          : "none"
                      }`}
                      onClick={() => handleInnerListItemClick("state")}
                    >
                      <Link
                        to="/masters/state"
                        className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                      >
                        <p
                          // onClick={() => setIsOpen(!isOpen)}
                          style={{ display: isOpen ? "block" : "none" }}
                        >
                          State
                        </p>
                      </Link>
                    </li>
                    {/* City */}
                    <li
                      className={`${
                        isOpen
                          ? headerText.includes("/masters/city")
                            ? "active block"
                            : "none"
                          : "none"
                      }`}
                      onClick={() => handleInnerListItemClick("city")}
                    >
                      <Link
                        to="/masters/city"
                        className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                      >
                        <p
                          // onClick={() => setIsOpen(!isOpen)}
                          style={{ display: isOpen ? "block" : "none" }}
                        >
                          City
                        </p>
                      </Link>
                    </li>
                    {/* Pincode */}
                    <li
                      className={`${
                        isOpen
                          ? headerText.includes("/masters/pincode")
                            ? "active block"
                            : "none"
                          : "none"
                      }`}
                      onClick={() => handleInnerListItemClick("pincode")}
                    >
                      <Link
                        to="/masters/pincode"
                        className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                      >
                        <p
                          // onClick={() => setIsOpen(!isOpen)}
                          style={{ display: isOpen ? "block" : "none" }}
                        >
                          Pincode
                        </p>
                      </Link>
                    </li>{" "}
                    {/* Country */}
                  </ul>
                  {/* </div> */}
                </Accordion.Body>
              </Accordion.Item>
            </OverlayTrigger>
            {/* settings tab end*/}

            {/* Customers  tab start*/}
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip("Drivers")}
              eventKey="4"
            >
              <Accordion.Item
                // eventKey="2"
                // className="mb-1"
                // onClick={() => setIsOpen(true)}
                eventKey="4"
                className={`mb-1 ${
                  activeAccordionItem === "4" ? "active" : ""
                }`}
                onClick={() => handleAccordionClick("4")}
              >
                <Accordion.Header>
                  <div className="text-clr  me-3">
                    <FontAwesomeIcon
                      icon={faTruck}
                      style={{ color: "rgb(45, 206, 137)" }}
                    />
                  </div>
                  <p
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    Drivers
                  </p>
                </Accordion.Header>
                <Accordion.Body
                  style={{
                    display: isOpen ? "block" : "none",
                  }}
                >
                  <ul className=" list-unstyled fw-normal pb-1 small">
                    {/* Language */}

                    <li
                      className={`${
                        isOpen
                          ? headerText.includes("/customers/driver")
                            ? "active block"
                            : "none"
                          : "none"
                      }`}
                      onClick={() => handleInnerListItemClick("driver")}
                    >
                      <Link
                        to="/customers/driver"
                        className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                      >
                        <p
                          // onClick={() => setIsOpen(!isOpen)}
                          style={{ display: isOpen ? "block" : "none" }}
                        >
                          Drivers
                        </p>
                      </Link>
                    </li>

                    <li
                      className={`${
                        isOpen
                          ? headerText.includes("/masters/training-video")
                            ? "active block"
                            : "none"
                          : "none"
                      }`}
                      onClick={() => handleInnerListItemClick("training-video")}
                    >
                      <Link
                        to="/masters/training-video"
                        className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                      >
                        <p
                          // onClick={() => setIsOpen(!isOpen)}
                          style={{ display: isOpen ? "block" : "none" }}
                        >
                          Drivers Training Video
                        </p>
                      </Link>
                    </li>

                    {/* Country */}
                  </ul>
                  {/* </div> */}
                </Accordion.Body>
              </Accordion.Item>
            </OverlayTrigger>

            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip("Customers")}
              eventKey="5"
            >
              <Accordion.Item
                // eventKey="2"
                // className="mb-1"
                // onClick={() => setIsOpen(true)}
                eventKey="5"
                className={`mb-1 ${
                  activeAccordionItem === "5" ? "active" : ""
                }`}
                onClick={() => handleAccordionClick("5")}
              >
                <Accordion.Header>
                  <div className="text-clr  me-3">
                    <FontAwesomeIcon
                      icon={faUser}
                      style={{ color: "rgb(45, 206, 137)" }}
                    />
                  </div>
                  <p
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    Customer
                  </p>
                </Accordion.Header>
                <Accordion.Body
                  style={{
                    display: isOpen ? "block" : "none",
                  }}
                >
                  <ul className=" list-unstyled fw-normal pb-1 small">
                    {/* Language */}

                    {/* Country */}

                    <li
                      className={`${
                        isOpen
                          ? headerText.includes("/customers/users")
                            ? "active block"
                            : "none"
                          : "none"
                      }`}
                      onClick={() => handleInnerListItemClick("country")}
                    >
                      <Link
                        to="/customers/users"
                        className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                      >
                        <p
                          // onClick={() => setIsOpen(!isOpen)}
                          style={{ display: isOpen ? "block" : "none" }}
                        >
                          Customer
                        </p>
                      </Link>
                    </li>
                  </ul>
                  {/* </div> */}
                </Accordion.Body>
              </Accordion.Item>
            </OverlayTrigger>
            {/* Customers  tab end*/}

            {/* Rides  tab start*/}

            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip("Bookings")}
              eventKey="6"
            >
              <Accordion.Item
                eventKey="6"
                className={`mb-1 ${
                  activeAccordionItem === "6" ? "active" : ""
                }`}
                onClick={() => handleAccordionClick("6")}
              >
                <Accordion.Header>
                  <div className="text-clr  me-3">
                    <FontAwesomeIcon
                      icon={faList}
                      style={{ color: "#2dce89" }}
                    />
                  </div>
                  <p
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    Bookings
                  </p>
                </Accordion.Header>
                <Accordion.Body
                  style={{
                    display: isOpen ? "block" : "none",
                  }}
                >
                  <ul className=" list-unstyled fw-normal pb-1 small">
                    <li
                      className={`${
                        isOpen
                          ? headerText.includes("/customers/rides")
                            ? "active block"
                            : "none"
                          : "none"
                      }`}
                      onClick={() => handleInnerListItemClick("rides")}
                    >
                      <Link
                        to="/customers/rides"
                        className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                      >
                        <p
                          // onClick={() => setIsOpen(!isOpen)}
                          style={{ display: isOpen ? "block" : "none" }}
                        >
                          Bookings
                        </p>
                      </Link>
                    </li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            </OverlayTrigger>
            {/* Rides  tab end*/}
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip("Enquiry")}
              eventKey="7"
            >
              <Accordion.Item
                // eventKey="2"
                // className="mb-1"
                // onClick={() => setIsOpen(true)}
                eventKey="7"
                className={`mb-1 ${
                  activeAccordionItem === "7" ? "active" : ""
                }`}
                onClick={() => handleAccordionClick("7")}
              >
                <Accordion.Header>
                  <div className="text-clr  me-3">
                    <FontAwesomeIcon
                      icon={faCircleExclamation}
                      style={{ color: "rgb(45, 206, 137)" }}
                    />
                  </div>
                  <p
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    Enquiry
                  </p>
                </Accordion.Header>
                <Accordion.Body
                  style={{
                    display: isOpen ? "block" : "none",
                  }}
                >
                  <ul className=" list-unstyled fw-normal pb-1 small">
                    {/* Language */}

                    <li
                      className={`${
                        isOpen
                          ? headerText.includes("/customers/contact-us")
                            ? "active block"
                            : "none"
                          : "none"
                      }`}
                      onClick={() => handleInnerListItemClick("contact-us")}
                    >
                      <Link
                        to="/customers/contact-us"
                        className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                      >
                        <p
                          // onClick={() => setIsOpen(!isOpen)}
                          style={{ display: isOpen ? "block" : "none" }}
                        >
                          Enquiry
                        </p>
                      </Link>
                    </li>

                    {/* Country */}
                  </ul>
                  {/* </div> */}
                </Accordion.Body>
              </Accordion.Item>
            </OverlayTrigger>

            {/* Adverticement  tab start*/}
            {/* <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip("Advertisement")}
              eventKey="9"
            >
              <Accordion.Item
                eventKey="9"
                className={`mb-1 ${
                  activeAccordionItem === "9" ? "active" : ""
                }`}
                onClick={() => handleAccordionClick("9")}
              >
                <Accordion.Header>
                  <div className="text-clr  me-3">
                    <FontAwesomeIcon
                      icon={faTv}
                      style={{ color: "rgb(45, 206, 137)" }}
                    />
                  </div>
                  <p
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    Advertisement
                  </p>
                </Accordion.Header>
                <Accordion.Body
                  style={{
                    display: isOpen ? "block" : "none",
                  }}
                >
                  <ul className=" list-unstyled fw-normal pb-1 small">
                    <li
                      className={`${
                        isOpen
                          ? headerText.includes("/masters/user-advertisement")
                            ? "active block"
                            : "none"
                          : "none"
                      }`}
                      onClick={() =>
                        handleInnerListItemClick("user-advertisement")
                      }
                    >
                      <Link
                        to="/masters/user-advertisement"
                        className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                      >
                        <p
                          // onClick={() => setIsOpen(!isOpen)}
                          style={{ display: isOpen ? "block" : "none" }}
                        >
                          User Advertisement
                        </p>
                      </Link>
                    </li>
                    <li
                      className={`${
                        isOpen
                          ? headerText.includes("/masters/rider-advertisement")
                            ? "active block"
                            : "none"
                          : "none"
                      }`}
                      onClick={() =>
                        handleInnerListItemClick("rider-advertisement")
                      }
                    >
                      <Link
                        to="/masters/rider-advertisement"
                        className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                      >
                        <p style={{ display: isOpen ? "block" : "none" }}>
                          Rider Advertisement
                        </p>
                      </Link>
                    </li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            </OverlayTrigger> */}
            {/* Adverticement  tab end*/}

            {/* Policy Content starts */}
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip("Policy Content")}
              eventKey="10"
            >
              <Accordion.Item
                eventKey="10"
                className={`mb-1 ${
                  activeAccordionItem === "10" ? "active" : ""
                }`}
                onClick={() => handleAccordionClick("10")}
              >
                <Accordion.Header>
                  <div className="text-clr  me-3">
                    <FontAwesomeIcon
                      icon={faShieldHalved}
                      style={{ color: "rgb(45, 206, 137)" }}
                    />
                  </div>
                  <p
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    Policy Content
                  </p>
                </Accordion.Header>
                <Accordion.Body
                  style={{
                    display: isOpen ? "block" : "none",
                  }}
                >
                  <ul className=" list-unstyled fw-normal pb-1 small">
                    <li
                      className={`${
                        isOpen
                          ? headerText.includes("/masters/privacy-policy")
                            ? "active block"
                            : "none"
                          : "none"
                      }`}
                      onClick={() => handleInnerListItemClick("privacy-policy")}
                    >
                      <Link
                        to="/masters/privacy-policy"
                        className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                      >
                        <p
                          // onClick={() => setIsOpen(!isOpen)}
                          style={{ display: isOpen ? "block" : "none" }}
                        >
                          Privacy Policy
                        </p>
                      </Link>
                    </li>
                    <li
                      className={`${
                        isOpen
                          ? headerText.includes("/masters/terms-and-conditions")
                            ? "active block"
                            : "none"
                          : "none"
                      }`}
                      onClick={() =>
                        handleInnerListItemClick("terms-and-condition")
                      }
                    >
                      <Link
                        to="/masters/terms-and-conditions"
                        className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                      >
                        <p
                          // onClick={() => setIsOpen(!isOpen)}
                          style={{ display: isOpen ? "block" : "none" }}
                        >
                          Terms And Conditions
                        </p>
                      </Link>
                    </li>

                    <li
                      className={`${
                        isOpen
                          ? headerText.includes(
                              "/masters/driver-privacy-policy"
                            )
                            ? "active block"
                            : "none"
                          : "none"
                      }`}
                      onClick={() =>
                        handleInnerListItemClick("driver-privacy-policy")
                      }
                    >
                      <Link
                        to="/masters/driver-privacy-policy"
                        className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                      >
                        <p
                          // onClick={() => setIsOpen(!isOpen)}
                          style={{ display: isOpen ? "block" : "none" }}
                        >
                          Driver Privacy Policy
                        </p>
                      </Link>
                    </li>

                    <li
                      className={`${
                        isOpen
                          ? headerText.includes(
                              "/masters/driver-terms-and-conditions"
                            )
                            ? "active block"
                            : "none"
                          : "none"
                      }`}
                      onClick={() =>
                        handleInnerListItemClick("driver-terms-and-conditions")
                      }
                    >
                      <Link
                        to="/masters/driver-terms-and-conditions"
                        className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                      >
                        <p
                          // onClick={() => setIsOpen(!isOpen)}
                          style={{ display: isOpen ? "block" : "none" }}
                        >
                          Driver Terms And Conditions
                        </p>
                      </Link>
                    </li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            </OverlayTrigger>
            {/* Policy Content Ends */}

            {/* Customer Supports starts */}
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip("Customer Support")}
              eventKey="11"
            >
              <Accordion.Item
                eventKey="11"
                className={`mb-1 ${
                  activeAccordionItem === "11" ? "active" : ""
                }`}
                onClick={() => handleAccordionClick("11")}
              >
                <Accordion.Header>
                  <div className="text-clr  me-3">
                    <FontAwesomeIcon
                      icon={faHeadset}
                      style={{ color: "rgb(45, 206, 137)" }}
                    />
                  </div>
                  <p
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    Customer Supports
                  </p>
                </Accordion.Header>
                <Accordion.Body
                  style={{
                    display: isOpen ? "block" : "none",
                  }}
                >
                  <ul className=" list-unstyled fw-normal pb-1 small">
                    <li
                      className={`${
                        isOpen
                          ? headerText.includes(
                              "/masters/customer-account-related-support"
                            )
                            ? "active block"
                            : "none"
                          : "none"
                      }`}
                      onClick={() =>
                        handleInnerListItemClick(
                          "customer-account-related-support"
                        )
                      }
                    >
                      <Link
                        to="/masters/customer-account-related-support"
                        className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                      >
                        <p
                          // onClick={() => setIsOpen(!isOpen)}
                          style={{ display: isOpen ? "block" : "none" }}
                        >
                          Account Related Support
                        </p>
                      </Link>
                    </li>

                    <li
                      className={`${
                        isOpen
                          ? headerText.includes(
                              "/masters/customer-fare-related-support"
                            )
                            ? "active block"
                            : "none"
                          : "none"
                      }`}
                      onClick={() =>
                        handleInnerListItemClick(
                          "customer-fare-related-support"
                        )
                      }
                    >
                      <Link
                        to="/masters/customer-fare-related-support"
                        className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                      >
                        <p
                          // onClick={() => setIsOpen(!isOpen)}
                          style={{ display: isOpen ? "block" : "none" }}
                        >
                          Fare Related Support
                        </p>
                      </Link>
                    </li>

                    <li
                      className={`${
                        isOpen
                          ? headerText.includes(
                              "/masters/customer-wallet-related-support"
                            )
                            ? "active block"
                            : "none"
                          : "none"
                      }`}
                      onClick={() =>
                        handleInnerListItemClick(
                          "customer-wallet-related-support"
                        )
                      }
                    >
                      <Link
                        to="/masters/customer-wallet-related-support"
                        className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                      >
                        <p
                          // onClick={() => setIsOpen(!isOpen)}
                          style={{ display: isOpen ? "block" : "none" }}
                        >
                          Wallet Related Support
                        </p>
                      </Link>
                    </li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            </OverlayTrigger>

            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip("Wallet")}
              eventKey="12"
            >
              <Accordion.Item
                eventKey="12"
                className={`mb-1 ${
                  activeAccordionItem === "12" ? "active" : ""
                }`}
                onClick={() => handleAccordionClick("12")}
              >
                <Accordion.Header>
                  <div className="text-clr  me-3">
                    <FontAwesomeIcon
                      icon={faWallet}
                      style={{ color: "rgb(45, 206, 137)" }}
                    />
                  </div>
                  <p
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    Wallet
                  </p>
                </Accordion.Header>
                <Accordion.Body
                  style={{
                    display: isOpen ? "block" : "none",
                  }}
                >
                  {" "}
                  {/* <li
                    className={`${
                      isOpen
                        ? headerText.includes("/wallet-fund-add-request")
                          ? "active block"
                          : "none"
                        : "none"
                    }`}
                    onClick={() =>
                      handleInnerListItemClick("driver-terms-and-condition")
                    }
                  >
                    <Link
                      to="/wallet-fund-add-request"
                      className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                    >
                      <p
                        // onClick={() => setIsOpen(!isOpen)}
                        style={{ display: isOpen ? "block" : "none" }}
                      >
                        Wallet Fund add Request{" "}
                      </p>
                    </Link>
                  </li>{" "} */}
                  <li
                    className={`${
                      isOpen
                        ? headerText.includes("/wallet-request")
                          ? "active block"
                          : "none"
                        : "none"
                    }`}
                    onClick={() =>
                      handleInnerListItemClick("driver-terms-and-condition")
                    }
                  >
                    <Link
                      to="/wallet-request"
                      className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                    >
                      <p
                        // onClick={() => setIsOpen(!isOpen)}
                        style={{ display: isOpen ? "block" : "none" }}
                      >
                        Wallet Withdrawal Request
                      </p>
                    </Link>
                  </li>{" "}
                  <li
                    className={`${
                      isOpen
                        ? headerText.includes("/wallet-history")
                          ? "active block"
                          : "none"
                        : "none"
                    }`}
                    onClick={() =>
                      handleInnerListItemClick("driver-terms-and-condition")
                    }
                  >
                    <Link
                      to="/wallet-history"
                      className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                    >
                      <p
                        // onClick={() => setIsOpen(!isOpen)}
                        style={{ display: isOpen ? "block" : "none" }}
                      >
                        Wallet History
                      </p>
                    </Link>
                  </li>
                </Accordion.Body>
              </Accordion.Item>
            </OverlayTrigger>

            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip("Rating And Review")}
              eventKey="13"
            >
              <Accordion.Item
                eventKey="13"
                className={`mb-1 ${
                  activeAccordionItem === "13" ? "active" : ""
                }`}
                onClick={() => handleAccordionClick("13")}
              >
                <Accordion.Header>
                  <div className="text-clr  me-3">
                    <FontAwesomeIcon
                      icon={faComment}
                      style={{ color: "rgb(45, 206, 137)" }}
                    />
                  </div>
                  <p
                    style={{
                      display: isOpen ? "block" : "none",
                    }}
                  >
                    Rating And Review
                  </p>
                </Accordion.Header>
                <Accordion.Body
                  style={{
                    display: isOpen ? "block" : "none",
                  }}
                >
                  {" "}
                  <li
                    className={`${
                      isOpen
                        ? headerText.includes("/rating-and-review")
                          ? "active block"
                          : "none"
                        : "none"
                    }`}
                    onClick={() =>
                      handleInnerListItemClick("rating-and-review")
                    }
                  >
                    <Link
                      to="/rating-and-review"
                      className="link-body-emphasis d-inline-flex text-decoration-none rounded"
                    >
                      <p
                        // onClick={() => setIsOpen(!isOpen)}
                        style={{ display: isOpen ? "block" : "none" }}
                      >
                        Rating And Review
                      </p>
                    </Link>
                  </li>{" "}
                </Accordion.Body>
              </Accordion.Item>
            </OverlayTrigger>
            {/* Policy Content Ends */}
          </Accordion>
        </ul>
      </section>
    </>
  );
};

export default Sidebar;
